module.exports = __webpack_public_path__ + "img/km.0f12d30.svg";